'use client';

import styled from '@emotion/styled';
import { IPoliciesSectionEntry } from '../../../../contentful';
import { Color } from '../../../../styles/Color';
import { TableRole, Responsive, H5, Css, H6 } from '../../../../ui';
import { PolicyListHeader } from '../../../resticted-policies/ui/PolicyListHeader';
import { PolicyListRow } from '../../../resticted-policies/ui/PolicyListRow';
import { Section } from './Section';

interface IPoliciesSectionProps {
	id: string;
	section: IPoliciesSectionEntry;
}

export default function PoliciesSection({
	id,
	section,
}: IPoliciesSectionProps) {
	const { title, description, items: categories } = section.fields;

	return (
		<StyledSection id={id}>
			{title && <SectionTitle>{title}</SectionTitle>}
			{description && <SectionDescription>{description}</SectionDescription>}

			{categories?.map((category) => (
				<CategoryBlock key={category.id}>
					<CategoryTitle>{category.fields.title}</CategoryTitle>

					<TableRole>
						<PolicyListHeader />
						{category.fields.items?.map((policy) => (
							<PolicyListRow key={policy.id} policy={policy} />
						))}
					</TableRole>
				</CategoryBlock>
			))}
		</StyledSection>
	);
}

const StyledSection = styled(Section)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0;
	}
`;

const SectionTitle = styled(H5)`
	line-height: normal;
	margin-bottom: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0 ${Css.pxToRem(16)} ${Css.pxToRem(16)};
	}
`;

const SectionDescription = styled.p`
	line-height: 1.6;
	color: ${Color.OnBackground};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0 ${Css.pxToRem(16)} ${Css.pxToRem(32)};
	}
`;

const CategoryBlock = styled.div`
	margin-bottom: ${Css.pxToRem(40)};

	&:last-of-type {
		margin-bottom: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: ${Css.pxToRem(32)};
	}
`;

const CategoryTitle = styled(H6)`
	padding: ${Css.pxToRem(16)} 0;
	margin: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		border-bottom: 1px solid ${Color.BorderCard};
		padding: ${Css.pxToRem(16)} ${Css.pxToRem(8)};
	}
`;
